import { handleVisibilityChange } from './visibility-change'

function iOSversion() {
  let userAgent = navigator.userAgent
  if (/iP(hone|od|ad)/.test(userAgent)) {
    // eslint-disable-next-line no-irregular-whitespace
    const v = userAgent.match(/OS\s+(\d+)_(\d+)_?(\d+)?/)
    return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)]
  } else {
    return []
  }
}

export function pageReloadInIOS12(cb) {
  try {
    const version = iOSversion()
    // console.log(version)
    if (+version[0] >= 12) {
      window.addEventListener(
        'pageshow',
        e => {
          if (
            e.persisted ||
            (window.performance && window.performance.navigation.type === 2)
          ) {
            location.reload()
          }
        },
        false
      )
      handleVisibilityChange(() => {
        location.reload()
      })
    }
  } catch (e) {
    console.error(e)
  }
}
